import React, { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './clickable-card.scss';

export const ClickableCard = memo(({ children, className = undefined, tag: Tag = 'div', ...rest }) => {
  return (
    <Tag className={classNames('clickable-card pos-r', className)} {...rest}>
      {children}
    </Tag>
  );
});

ClickableCard.displayName = 'ClickableCard';

ClickableCard.propTypes = {
  className: PropTypes.string,
  tag: PropTypes.string,
  children: PropTypes.node.isRequired,
};
